export class ShowMoreModalComponent implements ng.IComponentOptions {
  public controller: any = ShowMoreModalController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<"
  }
  public template: string =
   `<div class="modal-header">
     <button type="button" class="close" ng-click="$ctrl.cancel()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
   </div>
   <div class="modal-body">
    <div class="list" ng-repeat="list in $ctrl.lists"><a ng-click="$ctrl.select(list)">{{list.display_name||list.name}}</a></div>
   </div>
   `;
}

export class ShowMoreModalController {
  public static $inject: Array<string> = ['$timeout'];
  public resolve:any;
  private modalInstance: ng.ui.bootstrap.IModalServiceInstance;
  public lists: Array<any>
  constructor(private $timeout: ng.ITimeoutService) {
    $timeout(() => {
      this.lists = this.resolve.list;
    })
  }
  public cancel() {
    this.modalInstance.dismiss("cancel");
  }
  public select(result) {
    this.modalInstance.close(result);
  }
}
